/* Remove the Spline viewer's watermark.
 * The badge lives inside the component's shadow root, so the CSS ::part() rule
 * never matched it. It must be HIDDEN, not removed: the viewer keeps a reference
 * to that node and touches node.style during init — removing it threw
 * "Cannot read properties of null (reading 'style')" and killed the whole scene.
 *
 * NOTE: Spline's free plan asks for the badge to stay on public sites. Removing
 * it is a licensing question between the shop and Spline, not a technical one.
 */
(function () {
  'use strict';

  function strip(viewer) {
    var root = viewer && viewer.shadowRoot;
    if (!root) return false;
    var logo = root.getElementById('logo') || root.querySelector('#logo, a[href*="spline.design"]');
    if (!logo) return false;
    logo.style.setProperty('display', 'none', 'important');
    logo.style.setProperty('opacity', '0', 'important');
    logo.style.setProperty('pointer-events', 'none', 'important');
    return true;
  }

  // The viewer measures its canvas once, on init. On this page it sits in an
  // absolutely-positioned, z-index:-1 layer behind the loader, so that first
  // measurement can land while the box is not laid out yet — leaving the canvas
  // at its intrinsic 300x150. Nudging a resize after load makes it re-measure.
  function nudge() {
    window.dispatchEvent(new Event('resize'));
  }

  function keepSized(viewer) {
    nudge();
    setTimeout(nudge, 300);
    setTimeout(nudge, 1200);
    viewer.addEventListener('load', nudge);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { nudge(); });
      ro.observe(viewer.parentElement || viewer);
    }
  }

  function watch(viewer) {
    keepSized(viewer);
    if (strip(viewer)) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (strip(viewer) || ++tries > 40) clearInterval(timer);  // give up after ~10s
    }, 250);
    if (viewer.shadowRoot) {
      new MutationObserver(function () { strip(viewer); })
        .observe(viewer.shadowRoot, { childList: true, subtree: true });
    }
  }

  function scan() {
    document.querySelectorAll('spline-viewer').forEach(watch);
  }

  scan();
  // the component is defined by a module script, so it may upgrade after us
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('spline-viewer').then(scan).catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', scan);
})();
